export function initializeSharing(track) {
    document.querySelectorAll('[data-share-controls]').forEach(controls => {
        const share = controls.querySelector('[data-share]');
        const copy = controls.querySelector('[data-copy-link]');
        const status = controls.querySelector('[role="status"]');
        const fallback = controls.querySelector('[data-share-fallback]');
        const link = fallback.querySelector('input');
        let copyResetTimer;
        const setStatus = (message, announcementOnly = false) => {
            status.classList.toggle('visually-hidden', announcementOnly);
            status.textContent = message;
        };
        const data = {
            title: document.querySelector('h1')?.textContent.trim() || document.title,
            url: window.location.href,
        };
        if (!data.title.includes('Guitar Charts')) data.title += ' — Guitar Charts';
        // Sharing must start synchronously in a user gesture, including on Safari.
        share.hidden = typeof navigator.share !== 'function' ||
            (typeof navigator.canShare === 'function' && !navigator.canShare(data));
        controls.hidden = false;

        share.addEventListener('click', async () => {
            if (share.getAttribute('aria-disabled') === 'true') return;
            share.setAttribute('aria-disabled', 'true');
            setStatus('');
            try {
                const sharing = navigator.share(data);
                track('event', 'share_attempt', {method: 'native'});
                await sharing;
                // A resolved promise is a handoff, not proof of a published post.
                track('event', 'share_handoff', {method: 'native'});
            } catch (error) {
                if (error.name !== 'AbortError') setStatus('Sharing is unavailable. Try Copy link instead.');
            } finally {
                share.removeAttribute('aria-disabled');
            }
        });

        copy.addEventListener('click', async () => {
            if (copy.getAttribute('aria-disabled') === 'true') return;
            copy.setAttribute('aria-disabled', 'true');
            clearTimeout(copyResetTimer);
            copy.classList.remove('is-copied');
            setStatus('');
            try {
                await navigator.clipboard.writeText(data.url);
                fallback.hidden = true;
                copy.classList.add('is-copied');
                setStatus('Link copied.', true);
                copyResetTimer = setTimeout(() => copy.classList.remove('is-copied'), 2500);
                track('event', 'copy_link', {method: 'clipboard'});
            } catch {
                fallback.hidden = false;
                link.value = data.url;
                link.focus();
                link.select();
                setStatus('Could not copy automatically. Copy the selected link below.');
            } finally {
                copy.removeAttribute('aria-disabled');
            }
        });
    });
}
